<!--
     <ActionAI
       size='small'
       :unit="QUnit"
       :loading
       @transition="action_transition(transition_obj)"
     />
-->

<template>
  <div>
    <v-progress-circular
      v-if="loading"
      indeterminate
      :color="color"
      :size="size == 'small' ? 20 : 30"
    />
    <v-menu
      v-else-if="show_action"
      top
      offset-y
      content-class="qmkey-explorer-table-menu-contents"
    >
      <template v-slot:activator="{ attrs, on }">
        <div>
          <v-icon
            :small="size == 'small'"
            :large="size == 'large'"
            v-on="on"
            v-bind="attrs"  
            :color="color"
            @click="click"
          >
            mdi-assistant
          </v-icon>
        </div>
      </template>
      <v-list dense>
        <v-list-item
          v-for="action in unit.ai_actions"
          :key="action.id"
          @click.stop="do_action(action)"
        >
          <v-list-item-title>{{ action.label }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <AISuggestion
      :unit="unit"
      :loading="loading"
      ref="ai_suggestion"
      @transition="launch_transition"
    />
  </div>
</template>


<script>
 import AISuggestion from '@/components/explorer/AISuggestion.vue';

 export default {
   name: "ActionAI",

   components: {
     AISuggestion,
   },

   props: {
     size: {default: 'small'},
     unit: {required: true},
     loading: {type: Boolean, default: false},
     color: {},
   },

   data: (() => ({
     action_id: null,
   })),

   computed: {
     show_action() {
       return (this.unit.ai_actions || []).length > 0;
     },
   },

   mounted() {
     console.log("ActionAI: ", this.unit, this.unit.ai_transitions);
   },

   methods: {
     do_action(action) {
       console.log("DO ACTION", action);
       this.$refs.ai_suggestion.launch(action);
     },

     launch_transition(trans) {
       this.$emit('transition', trans);
     },

     click() {
       this.$emit('clicked');
     },
   },
 };
</script>
